/**
 * 大数据查询的api地址
 */
 export default{
    GetCategoryTree:'/prejobtraining/Catalogue/GetCategoryTree', //获取菜单的树结构
    GetApiInfo:'/bigData/BdApi/GetApiInfo', //获取分类Api信息
    ApiCodeInfo:'/bigData/BdApi/ApiCodeInfo', //获取大数据查询代码信息
    GetBigDataList:'/api/File/GetBigDataList', //获取大数据查询数据列表
    GetTsCodeList:'/api/PythonOnline/GetTsCodeList',// 获取股票代码列表
}


// WEBPACK FOOTER //
// ./src/api/urls/notice.js